module.exports = __webpack_public_path__ + "static/media/B_S01.12c5b898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_S01.png
// module id = 66
// module chunks = 0